import React from 'react';
import { useNetworkContext } from '@/contexts/NetworkContext';
import { useTabContext } from '@/contexts/TabContext';

import OverviewTab from '@/components/RightPanel/OverviewTab';
import HubsTab from '@/components/RightPanel/HubsTab';
import ServiceabilityTab from '@/components/RightPanel/ServiceabilityTab';
import ConnectionsTab from '@/components/RightPanel/ConnectionsTab';
import VisualiseTab from '@/components/RightPanel/VisualiseTab';
import TestRouteTab from '@/components/RightPanel/TestRouteTab';

const RightPanel: React.FC = () => {
  const { activeTab } = useTabContext();
  const { currentNetwork } = useNetworkContext();

  // Render active tab content
  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewTab currentNetwork={currentNetwork} />;
      case 'hubs':
        return <HubsTab />;
      case 'serviceability':
        return <ServiceabilityTab />;
      case 'connections':
        return <ConnectionsTab />;
      case 'visualise':
        return <VisualiseTab />;
      case 'testroute':
        return <TestRouteTab />;
      default:
        return <OverviewTab currentNetwork={currentNetwork} />;
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md h-full">
      {!currentNetwork ? (
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-primary-700 mb-4">Lyne Routes Builder</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A powerful tool for building and managing routes efficiently.
          </p>
          <div className="bg-gray-50 p-6 rounded-lg text-center mt-8">
            <p className="text-gray-600 mb-4">No network is currently selected.</p>
            <p className="text-gray-500">
              Click the chart icon on a network in the left panel to select it.
            </p>
          </div>
        </div>
      ) : (
        <div>
          <h2 className="text-2xl font-semibold text-primary-700 mb-4">{currentNetwork.name}</h2>
          {renderTabContent()}
        </div>
      )}
    </div>
  );
};

export default RightPanel;
